module.exports = __webpack_public_path__ + "img/logout.2df7ac70.svg";